import actionTypes from '../../common/actionTypes';

export function toggleNavigation() {
	return function toggleNavigationThunk(dispatch: any) {
		return dispatch({type: actionTypes.TOGGLE_NAV_MENU});
	};
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/navActions.ts